import GeneralDashboard from 'components/charts/general-dashboard/GeneralDashboard';
import FilterQueryGroup from 'components/filter/FilterQueryGroup';
import NewReleaseModal from 'components/modals/NewReleaseModal';
import useApi from 'helpers/api';
import { useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AgentsService from 'services/Agents.service';
import DashboardService from 'services/Dashboard.service';
import TicketsByCatalog from '../../charts/TicketsByCatalog';
import TicketsByAgent from '../../charts/by-agent/TicketsByAgent';
import TicketsByCustomer from '../../charts/by-customer/TicketsByCustomer';
import TicketsByServiceGroup from '../../charts/by-service-group/TicketsByServiceGroup';
import TicketsByPriority from './by-priority/TicketsByPriority';

const SupportDesk = () => {
  const api = useApi();
  const navigate = useNavigate();
  const [showReleaseModal, setShowReleaseModal] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    priority: '',
    agent: '',
    customer: '',
    serviceGroup: '',
    initialCreationDate: '',
    endCreationDate: ''
  });
  const [ticketsByCatalog, setTicketsByCatalog] = useState([]);
  const [ticketsByCustomer, setTicketsByCustomer] = useState([]);
  const [ticketByServiceGroups, setTicketsByServiceGroups] = useState([]);
  const [ticketsByAgent, setTicketsByAgent] = useState([]);
  const [ticketsByPriority, setTicketsByPriority] = useState([]);

  useEffect(() => {
    getData();
  }, [filters]);

  useEffect(() => {
    const isModalShown = localStorage.getItem('releaseModalShown_v2.3.4');

    if (!isModalShown) {
      setShowReleaseModal(true);
      localStorage.setItem('releaseModalShown_v2.3.4', 'true');
    }
    localStorage.removeItem('releaseModalShown_v2.3.3');

    verifyUserPassword();
  }, []);

  const verifyUserPassword = async () => {
    const authenticatedUser = await getAuthenticatedUser();
    if (!authenticatedUser?.id) {
      setError('Failed to get authenticated user');
      return;
    }

    const userId = authenticatedUser.id;
    // Finally get the user profile and check password reset requirement
    const profile = await getMyProfile(userId);
    if (profile?.passwordResetRequired) {
      navigate('/reset-password');
    }
  };

  const getAuthenticatedUser = async () => {
    const response = await AgentsService.getAuthenticatedUser();
    if (!response?.id) {
      throw new Error('Failed to get authenticated user');
    }
    return response;
  };

  const getMyProfile = async userId => {
    const response = await api.agents.myProfile(userId);
    if (!response.id) {
      throw new Error('Failed to get user profile');
    }
    return response;
  };

  async function getData() {
    try {
      const queryParams = new URLSearchParams(filters).toString();
      const [
        resTicketsByCatalog,
        resTicketsByCustomer,
        resTicketsByServiceGroup,
        resTicketsByAgent,
        resTicketsByPriority
      ] = await Promise.all([
        DashboardService.getTicketsByCatalog(queryParams),
        DashboardService.getTicketsByCustomer(queryParams),
        DashboardService.getTicketsByServiceGroup(queryParams),
        DashboardService.getTicketsByAgent(queryParams),
        DashboardService.getTicketsByPriority(queryParams)
      ]);
      setTicketsByCatalog(resTicketsByCatalog);
      setTicketsByCustomer(resTicketsByCustomer);
      setTicketsByServiceGroups(resTicketsByServiceGroup);
      setTicketsByAgent(resTicketsByAgent);
      setTicketsByPriority(resTicketsByPriority);
    } catch (error) {
      setError(error);
    }
  }

  const handleFilterChange = filtersChange => {
    setFilters(filtersChange);
  };

  return (
    <>
      <NewReleaseModal
        show={showReleaseModal}
        handleClose={() => setShowReleaseModal(false)}
      />
      <Card>
        <Card.Body>
          {error === null && (
            <>
              <Row className="g-3 mb-3 z-0">
                <Col>
                  <Row className="g-3">
                    <Row className="my-3">
                      <FilterQueryGroup
                        onFilterChange={handleFilterChange}
                        refreshData={() => getData()}
                      />
                    </Row>
                    <Row>
                      <GeneralDashboard filtersDash={filters} />
                    </Row>

                    <Row className="g-3">
                      <Col md={6} xxl={6}>
                        <TicketsByServiceGroup
                          data={ticketByServiceGroups}
                          filtersDash={filters}
                        />
                      </Col>
                      <Col md={6} xxl={6}>
                        <TicketsByCatalog
                          data={ticketsByCatalog}
                          title="Tickets em Aberto por Catálogo de Serviço"
                          filtersDash={filters}
                        />
                      </Col>
                    </Row>
                    <Row className="g-3">
                      <Col md={6} xxl={6}>
                        <TicketsByPriority
                          data={ticketsByPriority}
                          filtersDash={filters}
                        />
                      </Col>
                      <Col md={6} xxl={6}>
                        <TicketsByAgent
                          data={ticketsByAgent}
                          filtersDash={filters}
                        />
                      </Col>
                    </Row>
                    <Row className="g-3">
                      <Col md={12} xxl={12}>
                        <TicketsByCustomer
                          data={ticketsByCustomer}
                          filtersDash={filters}
                        />
                      </Col>
                    </Row>
                  </Row>
                </Col>
              </Row>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default SupportDesk;
